import React,{ useState } from "react";
import { Checkbox, Row, Col, Flex, Modal, Input, Button, Form } from "antd";
import useExportTemplateStore from "../../store/exportTemplate.store";

function ExportModal({ createTemplate }) {
  const [openResponsive, setOpenResponsive] = useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      // Validate form before proceeding
      const values = await form.validateFields();
      const { templateName } = values;
      createTemplate(templateName, setOpenResponsive, [
        "Resume ID",
        "Sourced On",
        "Sourced By",
        "Organization",
        "Payroll",
        "Candidate Name",
        "Contact No.",
        "Email",
        "Resume Suitability",
        "Total Work Exp",
        "Relevant Work Exp",
        "Current Location",
        "Preferred Location",
        "Highest Qualification",
        "Company",
        "Designation",
        "Current CTC",
        "Expected CTC",
        "Offered CTC",
        "CTC Remarks",
        "Official NP",
        "Negotiable NP",
        "LWD",
        "Reason for Leaving",
        "Candidate Status",
        "Remarks",
        "Resume Status",
        "Interview Type",
        "Interview Status",
        "Other Offers",
        "Other Joining Date",
      ]);
      form.resetFields();
    } catch (errorInfo) {
      console.log("Validation failed:", errorInfo);
    }
  };

  return (
    <div className="create-template">
      <Flex vertical gap="middle" align="flex-start">
        <Button type="primary" onClick={() => setOpenResponsive(true)}>
          + New Template
        </Button>

        <Modal
          title="Create a New Export Template"
          centered
          open={openResponsive}
          onOk={handleOk}
          onCancel={() => {
            setOpenResponsive(false);
            form.resetFields();
          }}
          width={{
            xs: "90%",
            sm: "80%",
            md: "60%",
            lg: "40%",
            xl: "30%",
            xxl: "20%",
          }}
        >
          <Form
            form={form}
            layout="vertical"
            name="exportTemplateForm"
            autoComplete="off"
          >
            <Form.Item
              label="Template Name"
              name="templateName"
              rules={[
                {
                  required: true,
                  message: "Please enter a template name!",
                },
              ]}
            >
              <Input
                style={{
                  height: "32px",
                  fontSize: "12px",
                  padding: "2px 8px",
                  textAlign: "left",
                }}
                placeholder="Enter Template Name"
              />
            </Form.Item>
          </Form>
        </Modal>
      </Flex>
    </div>
  );
}

export default ExportModal;
